/** Billing rules the screens need before asking the API (mirrors `CustomerAccount.timing_of`). */
import type { BillingPeriod, CustomerAccount, Plan } from "./types";

export type ChangeTiming = "none" | "now" | "period_end";

export function changeTiming(account: CustomerAccount, plan: Plan, period: BillingPeriod): ChangeTiming {
  const current = account.plan;
  const paid = plan.monthly_price_cents > 0;
  if (plan.key === current.key && (period === account.billing_period || !paid)) return "none";
  if (current.monthly_price_cents === 0 || !account.current_period_end) return "now";
  if (plan.rank > current.rank) return "now";
  if (plan.key === current.key && period === "annual") return "now";
  return "period_end";
}

/** Where "Choose <plan>" leads: checkout (paid today), the cancel review (to Free), or a scheduled change. */
export function choosePlanTarget(
  account: CustomerAccount,
  plan: Plan,
  period: BillingPeriod,
):
  | { kind: "checkout"; to: string }
  | { kind: "cancel"; to: string }
  | { kind: "schedule" }
  | { kind: "none" } {
  const timing = changeTiming(account, plan, period);
  if (timing === "none") return { kind: "none" };
  if (plan.monthly_price_cents === 0) return { kind: "cancel", to: "/billing/cancel" };
  if (timing === "now")
    return { kind: "checkout", to: `/billing/checkout?plan=${plan.key}&period=${period}` };
  return { kind: "schedule" };
}

export const periodLabel = (period: BillingPeriod | string | null): string =>
  period === "annual" ? "annual" : "monthly";
